export const operateMaxShowLength = 200